/**
 * Inline images are stored in rich text as an opaque reference rather than a URL.
 *
 * The URL that actually serves a file is environment-specific and cross-origin,
 * so persisting it would pin content written in one environment to that
 * environment's hosts forever. A custom scheme is used rather than a path
 * because it is obviously not fetchable — nothing downstream will try to load it
 * and silently render a broken image.
 */
export const FILE_REFERENCE_PREFIX = 'forecast-file:';

export const toFileReference = (fileId: string): string => `${FILE_REFERENCE_PREFIX}${fileId}`;

export const isFileReference = (value: string): boolean =>
	typeof value === 'string' && value.startsWith(FILE_REFERENCE_PREFIX) && value.length > FILE_REFERENCE_PREFIX.length;

/** Returns the file id, or null if this is not one of our references. */
export const fromFileReference = (reference: string): string | null =>
	isFileReference(reference) ? reference.slice(FILE_REFERENCE_PREFIX.length) : null;
